import de from './locales/de';

export const defaultLanguage = 'de';
export const languagesResources = { de };
